// ─────────────────────────────────────────────────────────────
//  SCHOOL DATA  –  Edit this file to update website content
// ─────────────────────────────────────────────────────────────

export const schoolInfo = {
  name: "St. Xavier's English Medium School",
  tagline: "Temple of Knowledge",
  location: "Guledgudd, Bagalkot, Karnataka",
  address: "Asangi Road, Guledgudd – 587203",
  taluk: "Guledgudd",
  district: "Bagalkot",
  state: "Karnataka",
  pincode: "587203",
  email: "stxavierseng2016@gmail.com",
  whatsapp: "9900256469",
  dise: "29020117506",
  founded: 2011,
  motto: "Sacrifice · Love · Service",
  medium: "English Medium",
  classes: "Nursery (LKG / UKG) to 10th Standard",
  administration: "Belgaum Diocese Board of Education",
  mapsUrl: "https://maps.google.com/?q=St+Xavier+English+Medium+School+Guledgudd",
};

export const principal = {
  name: "Fr. Francis Buddini",
  role: "Principal",
  message: [
    "Dear Students, Parents, and Well-Wishers,",
    "Warm greetings to you all. St. Xavier's English Medium School, Guledgudd, is a minority educational institution established with a noble mission to provide quality education, especially to children in rural areas and those from economically weaker sections of society. While rooted in Christian values and primarily serving Catholic students, our school warmly welcomes all, without distinction of caste, creed, or race.",
    "Our aim is to foster the all-round development of every child. Along with imparting academic knowledge, we place special emphasis on discipline, character building, and courtesy in speech and conduct. We believe that true education forms not only the mind but also the heart, shaping responsible and compassionate individuals.",
    "We prepare our students to face academic challenges with confidence, including the Secondary School Leaving Certificate (SSLC) examination of Karnataka State. At the same time, we actively encourage participation in co-curricular and inter-school activities to help students discover and develop their unique talents.",
    "Guided by our motto \"Sacrifice, Love, Service,\" we strive to form young minds who will become lights of the world — bringing positivity and goodness in their families, communities, and wherever they go.",
    "Despite the challenges of a rural setting, we remain committed to excellence through the dedication of our teachers and the support of parents. Together, we continue this mission of empowering lives through education.",
    "May God bless you all.",
  ],
};

export const stats = [
  { number: "2011", label: "Founded" },
  { number: "Nursery–10", label: "Classes" },
  { number: "100%", label: "SSLC Results" },
  { number: "2025", label: "Unified Campus" },
];

export const notices = [
  "🎉 Admissions Open 2026–27 — Nursery to 10th Standard",
  "🏆 100% SSLC Results — Congratulations to Our Students!",
  "🧘 International Yoga Day Celebrated with Full Participation",
  "🌱 Little Stars Play Park — Where Little Feet Make Big Memories",
  "✝ Guided by Sacrifice · Love · Service",
];

export const history = [
  {
    year: "2011",
    title: "The Journey Begins",
    phase: "Foundation",
    text: "St. Xavier's English Medium School began its educational journey with classes 6th to 10th standard. With a vision to provide quality English-medium education to the children of the region, the institution steadily gained the trust of parents and the community.",
  },
  {
    year: "2023",
    title: "Pre-Primary Wings Added",
    phase: "Expansion",
    text: "The school obtained official permission to start Nursery to 5th standard. These primary and pre-primary classes initially functioned in the Kannada Medium Primary School building, marking the beginning of a full-fledged English-medium stream.",
  },
  {
    year: "2025",
    title: "One Campus, One Family",
    phase: "Major Milestone",
    text: "All classes from Nursery to 10th were unified under a single campus — strengthening the school's identity, administrative unity, and its mission of holistic education. St. Xavier's emerged as a fully independent and vibrant institution.",
  },
];

export const aims = [
  {
    num: "01",
    title: "Inclusive Institution",
    text: "Established by Belgaum Diocese, welcoming all students without distinction of caste, creed, or race, primarily serving Catholic students.",
  },
  {
    num: "02",
    title: "All-Round Development",
    text: "Special emphasis on discipline, character building, and courtesy — forming the whole person, not just the academic mind.",
  },
  {
    num: "03",
    title: "Academic Excellence",
    text: "Preparing students confidently for the SSLC examination of Karnataka State with thorough academic preparation.",
  },
  {
    num: "04",
    title: "Co-Curricular Life",
    text: "Encouraging participation in curricular and co-curricular activities and inter-school competitions.",
  },
  {
    num: "05",
    title: "Living the Motto",
    text: "Enabling students to be lights of the world — at home, in school, in the neighborhood, and wherever they go.",
  },
];

export const facilities = [
  { icon: "💻", title: "Computer Laboratory", text: "A fully equipped lab enabling students to develop essential digital literacy and skills for the modern world.", image: "computerlab.jpeg" },
  { icon: "📚", title: "Well-Equipped Classrooms", text: "Bright, spacious classrooms designed to create an ideal learning environment for students of every level.", image: "building-wide.jpg" },
  { icon: "🎡", title: "Little Stars Play Park", text: '"Where Little Feet Make Big Memories" — a dedicated, safe, colourful playground for our youngest learners.', image: "playpark.jpeg" },
  { icon: "⚽", title: "Sports Ground", text: "A spacious open ground for sports, physical activity, yoga sessions, and inter-school competitions.", image: "playground.jpeg" },
  { icon: "🌳", title: "Green Campus", text: "A lush, open campus with ample greenery providing a serene and healthy environment for learning and growth.", image: "schoolground.jpeg" },
  { icon: "🏆", title: "Administrative Office", text: "A well-organized office adorned with trophies and certificates reflecting the school's proud achievements.", image: "principaloffice.jpeg" },
];

// ─── GALLERY ───────────────────────────────────────────────
// To add photos: put image files in src/assets/images/
// then import them here and add to the arrays below.
//
// Example:
//   import myPhoto from '../assets/images/sports-day.jpg';
//   { src: myPhoto, caption: 'Sports Day 2024', category: 'sports' }
//
// Categories: 'all' | 'cultural' | 'sports' | 'nature' | 'academic'

// Gallery images are imported in the Gallery component.
// See src/components/Gallery.jsx for instructions.

export const galleryCategories = [
  { key: "all", label: "All" },
  { key: "cultural", label: "Cultural" },
  { key: "sports", label: "Sports & Yoga" },
  { key: "nature", label: "Nature & Community" },
  { key: "academic", label: "Academic" },
];
